import PropTypes from 'prop-types';

// react-router
import { useNavigate } from 'react-router-dom';

// material-ui
import { Button } from '@mui/material';

// assets
import { ArrowLeft2 } from 'iconsax-react';

// ==============================|| BACK BUTTON ||============================== //
//
// Small, consistent "back to listing" control for detail pages. Pass `to` for
// an explicit destination (preferred); falls back to browser history (-1).

const BackButton = ({ to, label = 'Back' }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) navigate(to);
    else navigate(-1);
  };

  return (
    <Button
      variant="text"
      color="secondary"
      size="small"
      startIcon={<ArrowLeft2 size={16} />}
      onClick={handleClick}
      sx={{ alignSelf: 'center', whiteSpace: 'nowrap' }}
    >
      {label}
    </Button>
  );
};

BackButton.propTypes = {
  to: PropTypes.string,
  label: PropTypes.string,
};

export default BackButton;
